import axios from "axios";

import { useEffect } from "react";
import { usersSuccess } from "../../redux/features/users";

// export default function Users() {
//     const dispatch = useDispatch()
//   const fetchUsers = () => async (dispatch) => {
//     //   try {
//     //     await api
//     //       .get("https://jsonplaceholder.typicode.com/users")
//     //       .then((response) => dispatch(usersSuccess(response.data)));
//     //   } catch (e) {
//     //     return console.error(e.message);
//     //   }
//     try {
//       const res = await axios("https://jsonplaceholder.typicode.com/users");
//       dispatch(usersSuccess(res.data));
//       console.log(res.data);
//     } catch (e) {
//       console.log(e);
//     }
//   };
//   useEffect(() => {
//     fetchUsers();
//   }, []);
//   return <div></div>;
// }

import React from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";

export default function Users() {
  const dispatch = useDispatch();

  const [firstt, setfirst] = useState([]);
  const first = async () => {
    try {
      const response = await fetch(
        "https://jsonplaceholder.typicode.com/users"
      );

      const data = await response.json();
      console.log(data);

      //   const data = JSON.stringify(res.data);

      dispatch(usersSuccess(data));

      //   console.log({ res });
    } catch (e) {
      console.log(e);
    }
  };

  console.log({ firstt });
  useEffect(() => {
    first();
  }, []);

  return (
    <>
      <h1>JHello</h1>
    </>
  );
}
